import React, { useState, useEffect } from "react";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Paper,
  Grid
} from "@mui/material";
import {
  Description,
  People,
  LocalOffer,
  ReceiptLong,
  ShoppingCart
} from "@mui/icons-material";
import { useNavigate, useLocation, Routes, Route } from "react-router-dom";

import SidebarMenu from "./AdminPanel/SidebarMenu";
import TopBar from "./AdminPanel/TopBar";

import AdminSection from "./AdminSection";
import Section from "./Section";
import AdminProforma from "./AdminProforma";
import Proforma from "./Proforma";
import AdminClient from "./AdminClient";
import Client from "./Client";
import AdminPromotion from "./AdminPromotion";
import Promotion from "./Promotion";
import NewInvoice from "../Empresa/NuevaFactura/NewInvoice";
import AdminInvoice from "./AdminInvoice";
import RegisterPurchase from "./RegisterPurchase";

const AdminPanel = () => {
  const [open, setOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Prindela Service| Panel de Control";

    const isSuper = localStorage.getItem("is_superuser") === "true";
    const isAdmin = localStorage.getItem("is_admin") === "true";
    const isVendedor = localStorage.getItem("is_vendedor") === "true";

    if (!isSuper && !isAdmin && !isVendedor) {
      navigate("/");
    }
  }, [location, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("is_superuser");
    localStorage.removeItem("is_admin");
    localStorage.removeItem("is_vendedor");
    localStorage.removeItem("is_logged_in");
    localStorage.removeItem("user_email");
    navigate("/");
  };

  const handleSelect = (path) => {
    navigate(`/admin-panel/${path}`);
  };

  const tarjetas = [
    { title: "Nueva Factura", color: "#0870A2", icon: ReceiptLong, path: "registro/documento" },
    { title: "Secciones", color: "#0870A2", icon: Description, path: "secciones" },
    { title: "Consultar Documentos", color: "#0870A2", icon: ReceiptLong, path: "reporte/documento" },
    { title: "Registrar compras o gastos", color: "#0870A2", icon: ShoppingCart, path: "compras/registro" },
    { title: "Proformas", color: "#0870A2", icon: Description, path: "proformas" },
    { title: "Personas", color: "#0870A2", icon: People, path: "clientes" },
    { title: "Promociones", color: "#0870A2", icon: LocalOffer, path: "promociones" }
  ];

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f1f5ff" }}>
      <SidebarMenu
        open={open}
        setOpen={setOpen}
        submenuOpen={submenuOpen}
        setSubmenuOpen={setSubmenuOpen}
        handleSelect={handleSelect}
        handleLogout={handleLogout}
        navigate={navigate}
      />

      <Box sx={{ flexGrow: 1 }}>
        <TopBar open={open} setOpen={setOpen} />

        <AppBar
          position="static"
          sx={{
            bgcolor: "#1565C0",
            width: "95%",
            mx: "auto",
            borderRadius: 2,
            boxShadow: 3,
            mt: 2
          }}
        >
          <Toolbar>
            <Typography
              variant="h6"
              sx={{ color: "#fff", cursor: "pointer" }}
              onClick={() => navigate("/admin-panel")}
            >
              Panel de Control
            </Typography>
          </Toolbar>
        </AppBar>

        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <Paper
                sx={{
                  width: "95%",
                  mx: "auto",
                  mt: 4,
                  mb: 5,
                  p: 3,
                  borderRadius: 3,
                  bgcolor: "#fff"
                }}
              >
                <Typography sx={{ mb: 3, fontWeight: 600 }}>
                  Accesos rápidos
                </Typography>

                <Grid container spacing={3} justifyContent="center">
                  {tarjetas.map((item, i) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                      key={i}
                      onClick={() => handleSelect(item.path)}
                      sx={{ cursor: "pointer" }}
                    >
                      <Box
                        sx={{
                          p: 3,
                          borderRadius: 3,
                          border: "1px solid #ddd",
                          textAlign: "center",
                          transition: "0.25s",
                          "&:hover": {
                            transform: "scale(1.05)",
                            boxShadow: "0 8px 20px rgba(0,0,0,0.15)"
                          }
                        }}
                      >
                        <Box
                          sx={{
                            bgcolor: item.color,
                            borderRadius: "50%",
                            width: 60,
                            height: 60,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            mx: "auto",
                            mb: 1.5
                          }}
                        >
                          <item.icon sx={{ fontSize: 30, color: "#fff" }} />
                        </Box>
                        <Typography sx={{ fontWeight: 600 }}>
                          {item.title}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Paper>
            }
          />

          <Route path="registro/documento" element={<NewInvoice />} />
          <Route path="secciones" element={<AdminSection />} />
          <Route path="secciones/nueva" element={<Section />} />
          <Route path="reporte/documento" element={<AdminInvoice />} />
          <Route path="compras/registro" element={<RegisterPurchase />} />
          <Route path="proformas" element={<AdminProforma />} />
          <Route path="proformas/nueva" element={<Proforma />} />
          <Route path="clientes" element={<AdminClient />} />
          <Route path="clientes/nuevo" element={<Client />} />
          <Route path="promociones" element={<AdminPromotion />} />
          <Route path="promociones/nueva" element={<Promotion />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default AdminPanel;
